import create from 'zustand'
import { CouponType, ValidationCheckoutStore } from './types'

export const useCheckoutStore = create<ValidationCheckoutStore>()(set => {
  return {
    couponCode: '',
    setCouponCode: (code: string) => {
      set({ couponCode: code })
    },
    coupon: null,
    setCoupon: (newCoupon: CouponType) => {
      set({ coupon: newCoupon })
    },
    discount: 0,
    setDiscount: discount => {
      set({ discount: discount })
    },
  }
})
